export { GameplayBackground, GameplayBackgroundGradient } from './gameplay-background';
